/* Hallmark · component: auth card · genre: editorial · theme: host_ui.css (design.md tokens)
 * states: static container — no interactive states of its own; the controls inside carry theirs
 * containment: one layer, never nested
 */
import React, { ReactNode } from "react";

// The card holds the ways into an account — Google and email — and nothing
// else. Anything that talks about the account beyond that choice (terms, the
// opposite route, password help) sits on the page beneath it: the card's edge
// is what says "this is the decision", and a second thing inside it blunts that.
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div
      data-auth-card
      data-slot="card"
      className="rounded-lg border border-border bg-background p-5 shadow-sm sm:p-8"
    >
      {children}
    </div>
  );
}
